// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

.epr-students-table {
  margin-top: 1rem;
}
.epr-students-table table {
  margin-top: 1rem;
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}
.epr-students-table table thead {
  background-color: #b8d9ec;
  color: #000;
}
.epr-students-table table thead th {
  border-radius: 5px 5px 0 0;
  border-bottom: 1px solid #0A4064;
  background-color: #c0def0;
  color: #0A4064;
  font-size: 0.95rem;
  font-weight: 500;
  padding: 8px;
}
.epr-students-table table tbody tr:nth-child(even) {
  background-color: #f5f5f5;
}
.epr-students-table table tbody td {
  padding: 8px 12px;
  border-bottom: 1px solid #ddd;
}
.epr-students-table table .student-view-cell {
  text-align: center;
}
.epr-students-table table .student-view-cell .centered-button {
  display: flex;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/HistoricalRosterTable.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;AAFA;EACI,gBAAA;AAKJ;AAHI;EACI,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,eAAA;AAKR;AAHQ;EACI,yBAAA;EACA,WAAA;AAKZ;AAHY;EACI,0BAAA;EACA,gCAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AAKhB;AAAY;EACI,yBAAA;AAEhB;AACY;EACI,iBAAA;EACA,6BAAA;AAChB;AAGQ;EACI,kBAAA;AADZ;AAGY;EACI,aAAA;EACA,uBAAA;AADhB","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$lt-highlight: #FAFAD2;\n$grey0: #EDF0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"global/Colors\";\n\n.epr-students-table {\n    margin-top: 1rem;\n\n    table {\n        margin-top: 1rem;\n        width: 100%;\n        border-collapse: collapse;\n        font-size: 14px;\n\n        thead {\n            background-color: #b8d9ec; // approximate light blue\n            color: #000;\n\n            th {\n                border-radius: 5px 5px 0 0;\n                border-bottom: 1px solid $dk-blue;\n                background-color: #c0def0;\n                color: #0A4064;\n                font-size: 0.95rem;\n                font-weight: 500;\n                padding: 8px\n            }\n        }\n\n        tbody {\n            tr:nth-child(even) {\n                background-color: #f5f5f5;\n            }\n\n            td {\n                padding: 8px 12px;\n                border-bottom: 1px solid #ddd;\n            }\n        }\n\n        .student-view-cell {\n            text-align: center;\n\n            .centered-button {\n                display: flex;\n                justify-content: center;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
